type TextAreaProps = {
  name?: string;
  title?: string;
  subtitle?: string;
  required?: boolean;
  autoFocus?: boolean;
}

export const InputTextArea = ( { title, subtitle, required, name, autoFocus } : TextAreaProps ) => {
  return(
    <div className="flex flex-col gap-4">
      <div>
        { title &&
          <div className={ 'text-[#ABB0C7]' }>
            { title }
          </div>
        }
        { title &&
          <div className={ 'text-[#ABB0C7] text-xs' }>
            { subtitle }
          </div>
        }
      </div>
      <div className={ 'rounded-lg bg-[#05051D] flex' } >
        <div className={ 'w-full rounded-lg bg-[rgba(12,16,46,0.50)] text-sm border border-[#756BDE]' }>
          <textarea 
            name={ name }
            required={ required }
            autoFocus={ autoFocus }
            className={ 'w-full min-h-64 field-content rounded-md flex bg-transparent text-white text-base p-4 outline-none shadow-[0px_4px_10px_0px_rgba(90,125,251,0.0),0px_-8px_20px_0px_rgba(255,255,255,0.20)_inset] hover:shadow-[0px_4px_10px_0px_rgba(90,125,251,0.0),0px_-8px_20px_0px_rgba(90,125,251,0.20)_inset] focus:shadow-[0px_4px_10px_0px_rgba(90,125,251,0.40),0px_-8px_20px_0px_rgba(90,125,251,0.20)_inset] transition-all duration-200' }></textarea>
        </div>
      </div>
    </div>
  )
}